// extracted by mini-css-extract-plugin
module.exports = {"embedModule":"embed-module-module--embedModule--1CfDD","embedContainer":"embed-module-module--embedContainer--HMUWl","fullWidth":"embed-module-module--fullWidth--26A6V"};